import {
  Component,
  OnInit,
  Input,
  SimpleChanges,
  EventEmitter,
  Output,
} from '@angular/core';
import { JobseekerModel } from '@admin/jobseekers/shared/models/jobseeker-model';
import { OccupationCategorySelection } from '@admin/jobseekers/shared/models/occupation-category-selection';
import { JobseekerService } from '@admin/jobseekers/shared/services/jobseeker.service';
import { CommonLookupItem } from '@admin/shared/models/common-lookup-item.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'hr-jobseeker-subscription',
  templateUrl: './jobseeker-subscription.component.html',
  styleUrls: ['./jobseeker-subscription.component.less'],
  standalone: false,
})
export class JobseekerSubscriptionComponent implements OnInit {
  @Input()
  public jobseeker: JobseekerModel;

  @Input()
  public localities: CommonLookupItem<number, string>[];

  @Output()
  public onUpdate: EventEmitter<boolean> = new EventEmitter<boolean>();

  public dailyDigestOn: boolean;
  public leftColumnCategories: OccupationCategorySelection[];
  public rightColumnCategories: OccupationCategorySelection[];

  public selectedLocalities: CommonLookupItem<number, string>[];
  public lastSelectedLocality: CommonLookupItem<number, string>;

  public dailyDigestDescription: string;
  public active: string;
  public inactive: string;

  public isValidCombination: boolean;
  public invalidCombinationMessage: string;

  constructor(
    private jobseekerService: JobseekerService,
    private translationService: TranslateService
  ) {
    this.dailyDigestOn = false;
    this.leftColumnCategories = [];
    this.rightColumnCategories = [];
    this.selectedLocalities = [];
    this.lastSelectedLocality = null;
    this.isValidCombination = true;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['jobseeker'] && changes['jobseeker'].currentValue != null) {
      this.init();
    }
  }

  onSubscriptionSaveClick() {
    const checkedCategories = this.leftColumnCategories
      .filter((c) => c.isChecked)
      .concat(this.rightColumnCategories.filter((c) => c.isChecked));
    const selectedLocalities = this.selectedLocalities.map((l) => l.value);

    if (checkedCategories.length == 0 && selectedLocalities.length > 0) {
      this.isValidCombination = false;
      return;
    }
    this.isValidCombination = true;

    this.jobseekerService
      .updateSubscription(
        this.jobseeker.jobseekerId,
        checkedCategories,
        selectedLocalities,
        this.dailyDigestOn
      )
      .subscribe((r) => {
        this.onUpdate.emit(true);
      });
  }

  onSubscriptionCancelClick() {
    this.init();
  }

  public onLocalityOptionRemoveClick(
    locality: CommonLookupItem<number, string>
  ) {
    const index = this.selectedLocalities.indexOf(locality);
    if (index >= 0) {
      this.selectedLocalities.splice(index, 1);
    }
  }

  public onLocalityChange() {
    if (
      this.lastSelectedLocality &&
      !this.selectedLocalities.includes(this.lastSelectedLocality)
    ) {
      this.selectedLocalities.push(this.lastSelectedLocality);
    }
    this.lastSelectedLocality = null;
  }

  ngOnInit() {
    this.dailyDigestDescription = this.translationService.instant(
      'text.DailyDigestDescription'
    );
    this.active = this.translationService.instant('label.Active');
    this.inactive = this.translationService.instant('label.Inactive');
    this.invalidCombinationMessage = this.translationService.instant(
      'message.IncompleteSubscriptionInput'
    );
  }

  private init() {
    this.dailyDigestOn = this.jobseeker.dailyDigestOn;
    let categories = this.jobseeker.subscribedCategories.map((x) =>
      Object.assign({}, x)
    );
    this.leftColumnCategories = categories.slice(0, categories.length / 2);
    this.rightColumnCategories = categories.slice(
      categories.length / 2,
      categories.length
    );
    this.selectedLocalities = this.jobseeker.subscribedLocalities.map(
      (x) => this.localities.filter((l) => x == l.value)[0]
    );
  }
}
